export enum PageType {
  Front,
  Back,
  Page
}



// WEBPACK FOOTER //
// ./src/infrastructure/PageType.ts